import { render, staticRenderFns } from "./PsotAddEditIn.vue?vue&type=template&id=0695dc7e&scoped=true&"
import script from "./PsotAddEditIn.vue?vue&type=script&lang=js&"
export * from "./PsotAddEditIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0695dc7e",
  null
  
)

export default component.exports